/**
 * Referenz-Vollzeitwochen (explizit benannt).
 * Massgebliche Wochen-Sollstunden: verifiziertes Arbeitsmodell (Fixblöcke),
 * sonst gespeicherte Beschäftigung, sonst Pensum × 100 %-Woche.
 */
export const REFERENCE_FULLTIME_WEEK_GAV_H = 41.25;
export const REFERENCE_FULLTIME_WEEK_NON_GAV_H = 40;

/** @deprecated Bevorzugt API-Werte; nur letzter Fallback */
export const LEGACY_WEEK_GOAL_H = REFERENCE_FULLTIME_WEEK_GAV_H;

export const WEEK_SOLL_SOURCE_HINTS_DE = {
  work_schedule:
    "Aus verifiziertem Arbeitsmodell (Summe der Fixblöcke, z. B. 4,25 h + 4 h — nicht Pensum×100 %).",
  period_stored: "Gespeicherte Wochen-Sollzeit der Beschäftigungsperiode.",
  pensum_formula: "Ohne Arbeitsmodell: berechnet als Pensum × 100 %-Woche.",
};

export const WEEK_SOLL_SOURCE_LABELS_DE = {
  work_schedule: "Arbeitsmodell",
  period_stored: "Beschäftigung",
  pensum_formula: "Pensum × 100 %",
};

export function nominalWeekFromWeek100(week100, pensumPct = 100) {
  const w = Number(week100);
  const p = Number(pensumPct);
  if (!Number.isFinite(w) || w <= 0) return null;
  const pct = Number.isFinite(p) && p > 0 ? p : 100;
  return Math.round((w * (pct / 100)) * 100) / 100;
}

export function nominalDayFromNominalWeek(weekH) {
  if (!Number.isFinite(weekH) || weekH <= 0) return null;
  return Math.round((weekH / 5) * 100) / 100;
}

const gavDay = nominalDayFromNominalWeek(REFERENCE_FULLTIME_WEEK_GAV_H);

/** @deprecated Bevorzugt `uiWorkDefaults.nominalDayH` */
export const LEGACY_DAY_GOAL_H = gavDay ?? 8.25;

export function weekSollHintForSource(source) {
  return WEEK_SOLL_SOURCE_HINTS_DE[source] || WEEK_SOLL_SOURCE_HINTS_DE.pensum_formula;
}

export function weekSollLabelForSource(source) {
  return WEEK_SOLL_SOURCE_LABELS_DE[source] || WEEK_SOLL_SOURCE_LABELS_DE.pensum_formula;
}

/**
 * Anzeige-Soll: zuerst Modell-Ist (`goal` aus Zeitlogik), sonst nominale User-Woche/5.
 */
export function resolveDisplayDayGoalH(apiDayGoal, uiWorkDefaults) {
  if (typeof apiDayGoal === "number" && Number.isFinite(apiDayGoal)) return apiDayGoal;
  const n = uiWorkDefaults?.nominalDayH;
  if (typeof n === "number" && Number.isFinite(n)) return n;
  return LEGACY_DAY_GOAL_H;
}

export function resolveDisplayWeekGoalH(apiWeekGoal, uiWorkDefaults) {
  if (typeof apiWeekGoal === "number" && Number.isFinite(apiWeekGoal)) return apiWeekGoal;
  const n = uiWorkDefaults?.nominalWeekH;
  if (typeof n === "number" && Number.isFinite(n)) return n;
  return LEGACY_WEEK_GOAL_H;
}
